import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import withCurrency from '../../containers/withCurrency';
import { formatDate } from '../../utils/formatDateTime';
import { hasEventStartedByDateObject } from '../../utils/hasEventStarted';
import ChildItemsMinimal from '../ChildItems/ChildItemsMinimal';

const getItemName = (t, cartItem) =>
  cartItem.giftVoucherId ? t('weblink:giftVoucher') : cartItem.course;

const getCourseSummary = (t, cartItem) =>
  !cartItem.pathId && !cartItem.giftVoucherId
    ? `${cartItem.location?.name}, ${
        cartItem.deliveryMethod === 'lms'
          ? hasEventStartedByDateObject(cartItem.startDateTime)
            ? t('weblink:uponEnrolment')
            : // This is required to show the local date rather than the date in the timezone that the LMS event has been set up in.
              formatDate(DateTime.fromMillis(cartItem.startDateTime.ts))
          : formatDate(cartItem.startDateTime)
      }`
    : '';

const ItemSubtotal = ({ quantity, value }) => (
  <div className="item-subtotal">
    <span>x{quantity}</span>
    <span>{value}</span>
  </div>
);

ItemSubtotal.propTypes = {
  quantity: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

const CourseRows = ({ cartContent, formatCurrencyForCalculation, t }) => (
  <div className="SummaryCard__content">
    {cartContent.map((item, index) => (
      <Fragment key={item.id}>
        <div className="item-row">
          <p className="font-weight-bold item-name">{getItemName(t, item)}</p>
          <p className="item-summary">{getCourseSummary(t, item)}</p>

          <ItemSubtotal
            quantity={item.quantity}
            value={`${formatCurrencyForCalculation(item.subTotalAmount)}`}
          />

          {item.childItems && item.childItems.length > 0 && (
            <ChildItemsMinimal items={item.childItems} />
          )}

          {cartContent.length !== index + 1 && <hr className="item-end" />}
        </div>
      </Fragment>
    ))}
    <hr className="items-end" />
  </div>
);

CourseRows.propTypes = {
  t: PropTypes.func.isRequired,
  cartContent: MobxPropTypes.arrayOrObservableArray.isRequired,
  formatCurrencyForCalculation: PropTypes.func.isRequired,
};

export default withTranslation()(withCurrency(CourseRows));
